import { ContextMenuItem } from 'redesign';
import { useGetShiftClaimContract } from 'ogp/hooks/queryHooks/shiftclaims/useGetShiftClaimContract';
import { shiftAlerts, useAlert } from 'shared/components/alerts';
import { IconDocument1 } from 'assets/img';
import {
  ShiftApplicationCancelled,
  ShiftClaimCancelled,
} from 'shared/components/shift-detail-modal/components/tabs/cancelled/cancelled-table.types';
import { getPlatformClient } from 'shared/utils/platform-utils';
import { isApplicant } from '../../../components/tabs/helpers';

const useOgpGetCancelledActions = () => {
  const { alertSuccess, alertError } = useAlert();
  const getContract = useGetShiftClaimContract({
    onSuccess: () => alertSuccess(shiftAlerts.success.downloadOvo),
    onError: (e) => alertError(e),
  });

  const getCancelledActions = (candidate: ShiftApplicationCancelled | ShiftClaimCancelled) => {
    if ('isFlexWorker' in candidate && candidate.isFlexWorker === false) {
      return [];
    }

    return !isApplicant(candidate) && getPlatformClient() !== 'LEVELWORKS'
      ? [
          <ContextMenuItem key="ovo" onClick={() => getContract.mutate(candidate.claimId)}>
            <IconDocument1 /> Overeenkomst
          </ContextMenuItem>,
        ]
      : [];
  };

  return { getCancelledActions };
};

export { useOgpGetCancelledActions };
